<div class="content">
  <careposi-header (logoutHandler)="handleLogout()">
  </careposi-header>
  <careposi-sidebar
        [data]="sidebarMenu"
        [isExpanded]="sidebarExpanded"
        (toggleSidebarConplete)= "handleToggleSidebarComplete()"
        (toggleSidebar)="handleToggleSidebar($event)">
  </careposi-sidebar>
  <div class ="component-container-wrapper">
    <div class="component-container" [class.sidebarExpanded]="sidebarExpanded">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>
